import { NumberRangeGroup } from "../basic/filters/NumberRangeFormModal";
import { FilterConfig } from "../../types/common/filters";
import { CalendarIcon, GlobeIcon, ListUnorderedIcon, PersonIcon } from '@primer/octicons-react';
import { FilterGroup } from "./components/GroupedSelectFormModal";
import { getScoringUserSegmentFilter, ScoringUserSegment } from "../../types/api/scoring/scoring";

// Users
// Aggregated
export const activeAdsNumberConfig: NumberRangeGroup = {
    id: 'activeAdsNumberConfig',
    label: 'Диапазон по количеству активных объявлений',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const favoriteAdsNumberConfig: NumberRangeGroup = {
    id: 'favoriteAdsNumberConfig',
    label: 'Диапазон количеству добавленных в избранное',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

// Диапазон по количеству активных объявлений
export const activeAdsRangeConfig: NumberRangeGroup[] = [
    {
        id: 'activeAdsRangeConfigTotal',
        label: '',
        description: 'Общее количество активных объявлений',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    },
    {
        id: 'activeAdsRangeConfigAverage',
        label: '',
        description: 'Среднее количество активных объявлений',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    }
]

export const archiveAdsNumberConfig: NumberRangeGroup = {
    id: 'archiveAdsNumberConfig',
    label: 'Диапазон по количеству архивных объявлений',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const scoringRange: NumberRangeGroup = {
    id: 'scoringRange',
    label: 'Диапазон по скоринг-баллам',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: true,
        allowZero: true,
    }
}

// Detailed
export const countWatchRange: NumberRangeGroup = {
    id: 'countWatchRange',
    label: 'Диапазон по количеству просмотров',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
        allowDecimal: true,
    }
}

export const countAddFavoriteRange: NumberRangeGroup = {
    id: 'countAddFavoriteRange',
    label: 'Диапазон по количеству добавленных в избранное',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countTimeInSectionRange: NumberRangeGroup = {
    id: 'countTimeInSectionRange',
    label: 'Диапазон по времени пребывания в разделах',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countMessages: NumberRangeGroup = {
    id: 'countMessages',
    label: 'Диапазон по количеству сообщений',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

// Sections
// Aggregated
export const countActiveUsers: NumberRangeGroup = {
    id: 'countActiveUsers',
    label: 'Диапазон по количеству активных пользователей',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

// Диапазон по скоринг-баллам 
export const scoringLeadConfig: NumberRangeGroup = {
    id: 'scoringLeadConfig',
    label: '',
    description: 'Скоринг',
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: true,
        allowZero: true,
    }
}

export const scoringSellerConfig: NumberRangeGroup = {
    id: 'scoringSellerConfig',
    label: '',
    description: 'Скоринг',
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: true,
        allowZero: true,
    }
}


// Диапазон по времени пребывания в разделах (общее/среднее)
export const timeInSectionRangeConfig: NumberRangeGroup[] = [
    {
        id: 'timeInSectionRangeConfigTotal',
        label: 'Диапазон по времени пребывания в разделах (общее/среднее)',
        description: 'Общее время пребывания в разделах',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    },
    {
        id: 'avgTime',
        label: '',
        description: 'Среднее время пребывания в разделах',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    }
]

// Диапазон по времени пребывания в подразделах (общее/среднее)
export const timeInCatalogRangeConfig: NumberRangeGroup[] = [
    {
        id: 'timeInSectionRangeConfigTotal',
        label: 'Диапазон по времени пребывания в подразделах (общее/среднее)',
        description: 'Общее время пребывания в подразделах',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    },
    {
        id: 'avgTime',
        label: '',
        description: 'Среднее время пребывания в подразделах',
        fromValue: '',
        toValue: '',
        validation: {
            allowNegative: false,
            allowZero: true,
        }
    }
]

// Detailed
export const countTimeInSubsectionRange: NumberRangeGroup = {
    id: 'countTimeInSectionRange',
    label: 'Диапазон по времени пребывания в подразделах',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countTimeRange: NumberRangeGroup = {
    id: 'countTimeRange',
    label: 'Диапазон по времени',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countWatchAdRange: NumberRangeGroup = {
    id: 'countWatchAdRange',
    label: 'Диапазон по количеству просмотров объявлений',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countAllUsersRange: NumberRangeGroup = {
    id: 'totalUsers',
    label: 'Количество пользователей',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const countFavoriteAddRange: NumberRangeGroup = {
    id: 'countFavoriteAddRange',
    label: 'Диапазон по количеству добавленных в избранное',
    description: undefined,
    fromValue: '',
    toValue: '',
    validation: {
        allowNegative: false,
        allowZero: true,
    }
}

export const scoringFilters: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Период",
        mode: "full",
        icon: CalendarIcon
    },
    selectFilters: [
        {
            key: 'scoringUserType',
            label: 'Тип пользователя',
            options: [],
            icon: PersonIcon
        },
        {
            key: 'geography',
            label: 'География',
            options: [],
            icon: GlobeIcon
        },
        {
            key: 'category-subcategory',
            label: 'Раздел / подраздел',
            options: [],
            icon: ListUnorderedIcon
        }
    ]
}

export const scoringSegmentGroups: FilterGroup[] = [
    {
        id: "leads",
        label: "LEAD",
        items: [
            {
                value: ScoringUserSegment.COLD_LEADS,
                label: getScoringUserSegmentFilter(ScoringUserSegment.COLD_LEADS),
            },
            {
                value: ScoringUserSegment.WARM_LEADS,
                label: getScoringUserSegmentFilter(ScoringUserSegment.WARM_LEADS),
            },
            {
                value: ScoringUserSegment.HOT_LEADS,
                label: getScoringUserSegmentFilter(ScoringUserSegment.HOT_LEADS),
            },
        ],
    },
    {
        id: "sellers",
        label: "SELLAR",
        items: [
            {
                value: ScoringUserSegment.WEAK_SELLERS,
                label: getScoringUserSegmentFilter(ScoringUserSegment.WEAK_SELLERS),
            },
            {
                value: ScoringUserSegment.ACTIVE_SELLERS,
                label: getScoringUserSegmentFilter(ScoringUserSegment.ACTIVE_SELLERS),
            },
            {
                value: ScoringUserSegment.VERY_ACTIVE_SELLERS,
                label: getScoringUserSegmentFilter(
                    ScoringUserSegment.VERY_ACTIVE_SELLERS
                ),
            },
        ],
    },
];
